<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="لوي">
<h1><span dir="rtl">#لوي</span></h1>
<p><img alt=" " src="media/file1.png" style="width:2.78125in;height:0.33647in"/></p>
<p><span dir="rtl">نحن أقوياء في شخصيَّاتنا، ولكن لا بدَّ مِن وجود شخصٍ نضعف أمامه، شخص يخضِعك بنظراته، ويسعدك بأخرى، أمبر تفعلُ بي هذا وبكلِّ حرفيَّة، ربَّما لأنَّها تشبهُها كثيرًا، هي تحمل نفسَ رائحتها، وسع عينيها، ابتسامتها، وحتَّى تأثيرها عليَّ!</span></p>
<p><span dir="rtl">صحيحٌ هي أخذَت قصرَ قامتها ولون شعرها الذهبيّ مِن والدها، لكنَّها تبقى الأقرب في ملامحها إلى حبِّي الأوَّل، والدة أمبر (فنيسا ماكويني).</span></p>
<p><span dir="rtl">كنتُ أبلغُ مِن العمر السَّابعة حين رحلَت أمِّي، وأخذَني والدي إلى كوينز تاون للعمل على مشاريع عائلة ماكويني.</span></p>
<p><span dir="rtl">هي كانت حاملًا بأمبر وقتها، كنتُ أسمع حديثها مع نفسها مرارًا، خوفها على طفلتها، وشعورها بعدم الانتماء إلى عالَم زوجها الخطر، وأعماله غير القانونيَّة،</span></p>
<p><span dir="rtl">هي تحبُّه، لكنَّها خائفةٌ على مولودٍ لَم يرَ النور بعد.</span></p>
<p><span dir="rtl">وأيضًا كنتُ أسمع عن مشاعر الأمومة التي تكِنُّها نحوِي أنا<strong>، "هل يأكل جيِّدًا؟ هل يهتمُّ والده بأمر دراسته؟ إنَّه ذكيّ ووسيم! يا إله السماء، باركِه."</strong></span></p>
<p><span dir="rtl">كَوني أستطيع قراءة الأفكار، لَم أكن معتادًا على سماع أمور جيِّدة، أو اهتمام أحد مِن دون أن يكون ذلك بغرض مصلحةٍ ما، لا أعلم إذا ما كان هذا الذي جعلني أقترب منها، ولكنَّها حتمًا كانت دافئة كالصيف، ومزهرة كالربيع.</span></p>
<p><span dir="rtl">ولأنَّه ليس مِن العدل أن تغيبَ عن حاضري ولدَت أمبر، وُلِدَت بتفاصيلها الصغيرة التي كانت أشدَّ جمالًا وأكثر طهارة.</span></p>
<p><span dir="rtl">التفَّت أصابعُها الصغيرة الهشَّة حول سبَّابتي، وبوم بوم بوم!</span></p>
<p><span dir="rtl">أقسِمُ إنَّني استطعتُ سماعَ نبضي بوضوح، وكأنَّ قلبي وُضِعَ بجانب أذني:</span></p>
<p><strong><span dir="rtl">- عليك بحمايتها وإسعادها لوي، كُن جديرًا بما أوكلتُكَ به.</span></strong></p>
<p><span dir="rtl">لَم أكن أعلم إذا ما كان يجدر بي الشعور بالسعادة لأمر كهذا؛ لذا لَم أنبس بحرف واحد قط.</span></p>
<p><span dir="rtl">أعدتُ النَّظر إلى المخلوق الصغير أمامي، لتجبرني عيناها على القَسم بحمايتها وإسعادها إلى الأبد.</span></p>
<p><span dir="rtl">فلنقُل إنَّها لَم تجعل مشاعرها تقودها في هذا الأمر أبدًا، هي ببساطة جعلَتني أفعلها رغمًا عنِّي.</span></p>
<p><span dir="rtl">ذلك اليوم، يوم تعميد أمبر عند بلوغها الثَّانية مِن عمرها في كنيسة سان بيتر أنجيبيكن، أحسستُ بيدها تمسكُ معصمي، وتجذبُني بين الأروِقة ذات الجدران الحجريَّة.</span></p>
<p><span dir="rtl">غرفةٌ مظلمةٌ تضيئها شمعتان، يتراقص لهيبهما كالرَّمق الأخير مخلِّفتَين ظلالًا مخيفة.</span></p>
<p><span dir="rtl">همست:</span></p>
<ul class="line">
<li><span dir="rtl"><strong>أمِّي، ما الأمر؟</strong></span></li>
</ul>
<p><span dir="rtl">أجابت مِن دون النظر نحوي: <strong>مَن أنت لويس فانديزا؟</strong></span></p>
<p><span dir="rtl">- <strong>أمِّي، ما الذي يحدث؟</strong></span></p>
<p><strong><span dir="rtl">- أنتَ بالفعل تستطيع قراءة ما أفكِّر به، صحيح!</span></strong></p>
<p><span dir="rtl">هربَت شهقة منِّي إثر اكتشافها شيئًا لَم أبُح به حتَّى لوالدي، تراجعتُ إلى الخلف متمتِمًا بكلماتٍ مبهَمة.</span></p>
<p><span dir="rtl">أمسكَت بيدي مجدَّدًا، لمحتُ ابتسامتها مع بقايا ضوء الشمعة المحتضر.</span></p>
<p><strong><span dir="rtl">- لَم يكُن مِن الصَّعب عليَّ أن أدرك ذلك بالنَّظر إلى الأوقات الطويلة التي أكون فيها معك، وقلَّة خبرتك كونك كنتَ تستجيب لطلباتي قبل أن أتفوَّه بطلبها.</span></strong></p>
<p><span dir="rtl">أذكرُ حينها أنَّ عينَيَّ أصبحَتا زجاجيِّتَين تعكسان ما يدور في عقلي الصغير مِن خوفٍ وضياعٍ إثر غبائي وافتضاح أمري.</span></p>
<p><span dir="rtl">تقدَّمَت نحوِي أكثر لتغزو رائحتُها دواخلي مردفةً:</span></p>
<p><strong><span dir="rtl">- كونكَ مختلفًا عن الآخَرين لا يجعلك ليس منهم، بل يجعلكَ أضعف أحيانًا، وأقوى أضعافًا في أحيان أُخرى، أنا هنا، وسأعملُ على حمايتك وتعزيز موهبتك.</span></strong></p>
<p><span dir="rtl">وهذا تمامًا ما حدث خلال السنوات التِّسعِ التي احتضنَتني فيها.</span></p>
<p><strong><span dir="rtl">- لا تِثق بأحدٍ قط، الخوف موجودٌ ولكن تذكَّر، بقعة الأمان الوحيدة على هذه الأرض هي هنا، بين يدي الرَّب.</span></strong></p>
<p><span dir="rtl">وقعت لها، كلُّ جزءٍ منِّي وقع لها بأكمله!</span></p>
<p><span dir="rtl">محبوبتي.. أمِّي فنيسا.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?5913c023